import { computed, ComputedRef, Ref } from 'vue';
import toggleArray from '@dh-io-emh/shared/src/utils/array.util';
import ProductFilterMultiSelect from '@dh-io-emh/shared/src/models/product-filter/product-filter-multi-select.model';

export const useFilterOptions = ({
  filter,
  emit,
  exclude,
  type = 'multiSelect',
}: {
  filter: Ref<ProductFilterMultiSelect> | ComputedRef<ProductFilterMultiSelect>;
  emit: (event: 'change', ...args: any[]) => void;
  exclude?: { key: string; value: any }[];
  type?: string;
}) => {
  const filterOptions = computed(() => {
    if (exclude) {
      return filter.value.options.filter((option) => {
        return exclude.some((field) => option[field.key] !== field.value);
      });
    }

    return filter.value.options;
  });

  const toggleOption = (option: string) => {
    const { code, value: filterValue } = filter.value;
    const { resultArray: newFilterValue, wasAdded } = toggleArray(filterValue, option);

    emit('change', {
      filterCode: code,
      filterValue: newFilterValue,
      filterType: type,
      filterCurrentlySelectedItemValue: option,
      selected: wasAdded,
    });
  };

  return {
    filterOptions,
    toggleOption,
  };
};
